var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show-root-toutiao"}},[_c('router-view'),_vm._v(" "),_c('footer-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/toutiaoApp/index.vue?vue&type=template&id=1431bea5&scoped=true&
// module id = null
// module chunks = 